export const DD_CONSTANTS = {
  PORTAL: 'portal',
  USER_TYPE: 'user_type',
};

export const PORTAL_VALUE_UNKNOWN = 'unknown';
